import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Http, Headers, Response, RequestOptions } from '@angular/http';

import { Observable } from 'rxjs/Observable';
import { environment } from './../../../../../environments/environment';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import 'rxjs/add/observable/throw';
@Injectable()
export class PreventiveMaintenanceAssignFormService {
  private urlPrefix: string = environment.appUrl;

  constructor(private httpClient: HttpClient) { }

  assignForms(pmId: string, eqDetailId: string, forms: Array<{formId, num}>): Observable<any> {
    const url = this.urlPrefix + `forms/pms/${pmId}/equipment-detail/${eqDetailId}`;
    return this.httpClient.put(url, { formListModel: forms}, {
      observe: 'response'
    })
    .map(res => {
      if (res.status === 200) {
        return res.body;
      } else {
        return Observable.throw(null);
      }
    })
    .catch(err => {
      return Observable.throw(err);
    });
  }

  getForms(pmId, eqDetailId): Observable<any> {
    const url = this.urlPrefix + `forms/pms/${pmId}/equipment-detail/${eqDetailId}`;
    return this.httpClient.get(url, {
      observe: 'response'
    })
    .map(res => {
      if (res.status === 200) {
        return res.body;
      } else {
        return Observable.throw(null);
      }
    })
    .catch(err => {
      return Observable.throw(err);
    });
  }

  getForm(formId, isSpecial, pmId, eqDetailId): Observable<any> {
    const url = this.urlPrefix + `forms/${formId}/pms/${pmId}/equipment-detail/${eqDetailId}/pdf`;

    return this.httpClient.get(url, {
      observe: 'response',
      responseType: 'blob',
      params: {
        isSpecial
      }
    })
    .map(res => {
      if (res.status === 200) {
        return {
          file: res.body,
          fileName: res.headers.get('content-disposition').replace('attachment;filename=', '')
        };
      } else {
        return Observable.throw(null);
      }
    })
    .catch(err => {
      return Observable.throw(err);
    });
  }

  getFormTemplate(formId): Observable<any> {
    const url = this.urlPrefix + `forms/${formId}/pdf`;

    return this.httpClient.get(url, {
      observe: 'response',
      responseType: 'blob'
    })
    .map(res => {
      if (res.status === 200) {
        return {
          file: res.body,
          fileName: res.headers.get('content-disposition').replace('attachment;filename=', '')
        };
      } else {
        return Observable.throw(null);
      }
    })
    .catch(err => {
      return Observable.throw(err);
    });
  }

}



// WEBPACK FOOTER //
// /Users/adminuser/Documents/pentagon/pentagon-admin/src/app/views/home/preventive-maintenance/preventive-maintenance-assign-form/preventive-maintenance-assign-form.service.ts